import { createFileRoute } from '@tanstack/react-router';
import { useAccessContext } from '@vizit/access';
import { EntityGrid } from '@vizit/organisms';
import { guardPortfolioWorkspaces } from '../../../../router/route-utils';
import { workspaceRoute } from '../../../../router/workspace-routes';
import { HierarchyGridPage } from '../../../../templates';

export const Route = createFileRoute('/_authenticated/portfolios/$portfolioId/workspaces')({
  staticData: {
    pageName: 'Workspaces',
  },
  beforeLoad: async ({ context, params }) => {
    await guardPortfolioWorkspaces(context, params.portfolioId);
  },
  component: PortfolioWorkspacesRoute,
});

function PortfolioWorkspacesRoute() {
  const { portfolioId } = Route.useParams();
  const { me, isLoading } = useAccessContext();
  const portfolio = me?.organization.portfolios.find((node) => node.id === portfolioId);

  const items =
    portfolio?.workspaces.map((workspace) => ({
      id: workspace.id,
      name: workspace.name,
      href: workspaceRoute(workspace.slug),
    })) ?? [];

  return (
    <HierarchyGridPage title={portfolio?.name ?? 'Workspaces'} className="gap-8">
      <EntityGrid items={items} isLoading={isLoading} emptyState={<p>No workspaces in this portfolio.</p>} />
    </HierarchyGridPage>
  );
}
